/**
 * FACELIFT 2026: benefit bar (snippets/bb-pdp-benefit-bar.liquid)
 * Pause/play button of the scrolling benefits (aria-pressed = paused). The state lives in the module, so it survives
 * the re-render on variant change (assets/rerender.js replaces the bar).
 */

let paused = false;

class BbBenefitBar extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.bb-benefit-bar__toggle');
    this.toggle?.addEventListener('click', () => {
      paused = !paused;
      this.update();
    });
    this.update();
  }

  update() {
    this.classList.toggle('is-paused', paused);
    this.toggle?.setAttribute('aria-pressed', String(paused));
  }
}

if (!customElements.get('bb-benefit-bar')) {
  customElements.define('bb-benefit-bar', BbBenefitBar);
}
